// ── Adapter Supabase do IWorkspaceConfigRepository ────────────────
// Acesso legacy à coluna `pipelines.loss_reasons`.

import { getSupabase } from '@infra/supabase/client';
import type { IWorkspaceConfigRepository, PipelineLossReasonsInfo } from '@modules/config';

interface PipelineLossReasonsRow {
  id: string;
  name: string;
  role: string | null;
  loss_reasons: unknown;
  funnel: { id: string; name: string } | null;
}

export class SupabaseWorkspaceConfigRepository implements IWorkspaceConfigRepository {
  listPipelinesWithLossReasons = async (workspaceId: string): Promise<PipelineLossReasonsInfo[]> => {
    if (!workspaceId) return [];
    const supabase = getSupabase();
    if (!supabase) return [];

    const { data, error } = await supabase
      .from('pipelines')
      .select('id, name, role, loss_reasons, funnel:funnels ( id, name )')
      .eq('workspace_id', workspaceId)
      .eq('ativo', true)
      .order('role')
      .order('name');

    if (error) {
      console.warn('[SupabaseWorkspaceConfigRepository] listPipelinesWithLossReasons:', error.message);
      return [];
    }

    return ((data || []) as unknown as PipelineLossReasonsRow[]).map(p => ({
      id: p.id,
      name: p.name,
      role: p.role,
      funnel_name: p.funnel?.name || null,
      loss_reasons: Array.isArray(p.loss_reasons) ? (p.loss_reasons as string[]) : [],
    }));
  };

  updatePipelineLossReasons = async (pipelineId: string, reasons: string[]): Promise<void> => {
    const supabase = getSupabase();
    if (!supabase) throw new Error('Supabase não configurado');
    const { error } = await supabase
      .from('pipelines')
      .update({ loss_reasons: reasons })
      .eq('id', pipelineId);
    if (error) throw error;
  };
}
